// O mapa efetivo vem do servidor; o fallback preserva contas ainda em carregamento.
export const isAccountModuleEnabled = (account, name) => {
  if (!account) return false;
  const effective = account.available_modules?.[name];
  if (typeof effective === 'boolean') return effective;

  const preference = account.feature_modules?.[name];
  // Modulos opt-in sem gate legado: so aparecem com a preferencia ligada.
  if (['synapse', 'support_assistant', 'jarvis', 'flow_library'].includes(name))
    return preference === true;
  if (preference === false) return false;

  switch (name) {
    case 'kanban':
      return (
        account.features?.kanban === true ||
        account.settings?.crm_enabled === true
      );
    case 'internal_chat':
      return account.features?.internal_chat_pro === true;
    case 'flows':
      return account.settings?.flows_enabled === true;
    case 'disparador':
      return account.settings?.broadcasts_enabled === true;
    default:
      return false;
  }
};
